<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import apiRes from './core/apiRes'

export default {
  beforeCreate () {
    document.cookie = 'j=true'
    apiRes.instance = this
  },
}
</script>

<style>
@import "../assets/css/main.css";
</style>
